import React from "react";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import zonesData from "./zonesData.json";
import "./zoneDropdown.css";

export default function ZoneDropdown({
  municipality,
  selectedZones = [],
  setSelectedZones,
}) {
  const zones = zonesData.zones[municipality] || [];

  const toggleZone = (zone) => {
    if (!selectedZones) return;

    if (selectedZones.includes(zone)) {
      setSelectedZones(selectedZones.filter((z) => z !== zone));
    } else {
      setSelectedZones([...selectedZones, zone]);
    }
  };

  const formatLocationName = (name) => {
    if (!name) return "";
    if (
      name === "Askim-frölunda-högsbo" ||
      name === "Örgryte-härlanda" ||
      name === "Majorna-linné"
    )
      return name
        .split("-")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join("-");
    return name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <div className="zones-section">
      <hr />
      <p className="zones-title">Område?</p>
      <div className="zones-checkboxes">
        {zones.map((zone) => (
          <Checkbox
            key={zone}
            label={formatLocationName(zone)}
            isChecked={selectedZones.includes(zone)}
            onChange={() => toggleZone(zone)}
          />
        ))}
      </div>
    </div>
  );
}
